import { createSlice } from "@reduxjs/toolkit";

interface ICurrency {
  id: string;
  code: string;
  name: string;
}

interface InitialState {
  currencies: ICurrency[];
}

const initialState: InitialState = {
  currencies: [],
};

const utilsSlice = createSlice({
  name: "utils",
  initialState,
  reducers: {
    setCurrency(state, action) {
      state.currencies = action.payload;
    },
  },
});

export const { setCurrency } = utilsSlice.actions;

export const selectCurrencies = (state: any) => state.utils.currencies;

export default utilsSlice.reducer;
